import React from 'react';
import FormationPlayerCard from '../formationPlayerCard';
import TeamDetail from '../teamDetail';
import Button from '../button';
import Typo from '../typo';
import SelectionPercentage from '../selectionPercentage';
import MatchPlayerStatus from '../matchPlayerStatus';
import { IMG_BASE_PATH } from 'utils/constants';
import { setClassName, setPlayerCard, setPlayerInfoOverlay } from 'store/slice/overlaySlice';
import { useDispatch } from 'react-redux';
import TotalPoints from '../totalPoints';
import { useMatch } from 'react-router-dom';
import { setToastMessage } from 'store/slice/toastMessageSlice';

const PlayerLists = ({
  players,
  handleAddRemovePlayer,
  selectedPlayer,
  isshow,
  phasePlayerMap,
  phaseshow,
  phaseData,
  matchDetails
}) => {
  const dispatch = useDispatch();
  const match = useMatch('/playerlist');
  const currentPhaseId = matchDetails?.phase_id;

  // Retrieve current phase data
  const playerPhaseData = phaseData?.phase_id === currentPhaseId ? phaseData : null;

  // Extract player IDs from current phase data
  const currentPhasePlayers = playerPhaseData?.player_id || [];

  const isPlayerSelected = (playerId) => selectedPlayer?.some((player) => player.id === playerId);
  const selectedSkillIds = selectedPlayer?.map((player) => player.skill_id);

  const handleToastMessage = (open, message, type) => {
    dispatch(setToastMessage({ toastMessageState: { open: open, message: message, type: type } }));
  };

  return (
    <>
      <div className='si-playerList'>
        {isshow && (
          <div className='si-playerList-head'>
            <div className='si-playerList-row'>
              <div className='si-playerList__tbl'>
                <div className='si-playerList__tbl-cell si--cellOne'>
                  <Typo
                    transKey='player_list_titile_name'
                    component='p'
                    className='si-playerList__tbl-cell-title'
                  ></Typo>
                </div>
                <div className='si-playerList__tbl-cell si--cellTwo'>
                  <Typo
                    transKey='player_list_titile_picked_by_percentage'
                    component='p'
                    className='si-playerList__tbl-cell-title'
                  ></Typo>
                </div>
                <div className='si-playerList__tbl-cell si--cellThree'></div>
              </div>
            </div>
          </div>
        )}

        {players?.map((player, index) => {
          const isPlayerFromSameCountrySelected =
            selectedPlayer?.filter((p) => p.team_name === player.team_name)?.length >= 2;

          // Check if the player is already taken in the current phase
          const playerIndex = currentPhasePlayers.indexOf(player.id);
          const isPhasePlayer = playerIndex !== -1;
          const gameDay = isPhasePlayer ? playerPhaseData?.team_gameday_id[playerIndex] : null;

          return (
            <div
              key={`${player.id}-${index}`}
              className={`si-playerList-row ${isPhasePlayer ? 'si-disabled' : ''} ${
                selectedPlayer?.length > 0 &&
                !isPlayerSelected(player.id) &&
                (selectedSkillIds?.includes(player.skill_id) || isPlayerFromSameCountrySelected)
                  ? 'si-disabled'
                  : ''
              }`}
              onClick={() => {
                if (isPhasePlayer) {
                  handleToastMessage(
                    true,
                    `Player already taken in this phase on game day ${gameDay}`,
                    3
                  );
                } else if (
                  isPlayerFromSameCountrySelected &&
                  !selectedSkillIds?.includes(player.skill_id)
                ) {
                  handleToastMessage(
                    true,
                    'You can select a maximum of 2 players from the same team',
                    3
                  );
                } else if (
                  selectedPlayer?.length > 0 &&
                  !isPlayerSelected(player.id) &&
                  selectedSkillIds?.includes(player.skill_id)
                ) {
                  switch (player.skill_name.toLowerCase()) {
                    case 'batter':
                      handleToastMessage(true, 'Maximum number of batters selected', 3);
                      break;
                    case 'bowler':
                      handleToastMessage(true, 'Maximum number of bowlers selected', 3);
                      break;
                    case 'all rounder':
                      handleToastMessage(true, 'Maximum number of all rounders selected', 3);
                      break;
                    default:
                      handleToastMessage(
                        true,
                        'You can select a maximum of 2 players from the same team',
                        3
                      );
                      break;
                  }
                }
              }}
            >
              <div className='si-playerList__tbl'>
                <div className='si-playerList__tbl-cell si--cellOne'>
                  <div className='playerCard'>
                    <div
                      className='playerCard-lhs'
                      onClick={() => {
                        dispatch(setPlayerInfoOverlay(true));
                        dispatch(setPlayerCard(player));
                        (isPhasePlayer ||
                          (!isPlayerSelected(player.id) &&
                            (selectedSkillIds?.includes(player.skill_id) ||
                              isPlayerFromSameCountrySelected))) &&
                          dispatch(setClassName(true));
                      }}
                    >
                      <FormationPlayerCard
                        thumbnail={player?.id}
                        fallback={`${IMG_BASE_PATH}images/players/2.png`}
                      />
                    </div>
                    <div className='playerCard-rhs'>
                      <FormationPlayerCard plyrName={player.name} />
                      <TeamDetail teamName={player.team_name} teamFlag={player.team_id} />

                      {phaseshow && phasePlayerMap[player.id] && (
                        <MatchPlayerStatus matchId={phasePlayerMap[player.id]} />
                      )}
                    </div>
                  </div>
                </div>
                {isshow && (
                  <div className='si-playerList__tbl-cell si--cellTwo'>
                    <SelectionPercentage percentage={`${player.sel_per}%`} />
                  </div>
                )}
                <div className='si-playerList__tbl-cell si--cellCta'>
                  {isshow && (
                    <Button
                      variant='onlyIcon'
                      icon={isPlayerSelected(player.id) ? 'lms-close' : 'lms-add'}
                      classes={isPlayerSelected(player.id) ? '' : 'si-btn__playerAdd'}
                      onClick={() => handleAddRemovePlayer(player)}
                      disabled={
                        isPhasePlayer ||
                        (!isPlayerSelected(player.id) &&
                          (selectedSkillIds?.includes(player.skill_id) ||
                            isPlayerFromSameCountrySelected))
                      }
                    />
                  )}
                  {match && (
                    <TotalPoints
                      totalPoints={player?.ov_pts}
                      addCls={'si--totalPoints'}
                      // hideIcon={true}
                    />
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default PlayerLists;
